import React from 'react'
import { When } from 'react-if'
import { CircleCheckIcon } from '@/atoms/Icons/CircleCheckIcon'
import { AsDiv, AsSpan, CaptionSM, HeadingLG, TitleSM, TitleXS } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { PromoPrice } from './form'
import { GuildGiftContext } from './state'

export function PromoCard() {
  const { state } = React.useContext(GuildGiftContext)
  const { t } = useTranslate('guild')

  return (
    <div className="flex flex-col gap-2 rounded-2xl bg-core-gray-300 p-6 text-core-gray-950 shadow-lg md:mb-12 lg:mb-0">
      <TitleXS weight="semibold" as={AsDiv} color="core-gray-700">
        {t('addSomeoneToYourAccount', 'Add someone to your account')}:
      </TitleXS>
      <div>
        <HeadingLG as={AsSpan} weight="bold" className="inline-flex gap-[14px]">
          <PromoPrice normalPrice={1200} promoPrice={600} />
        </HeadingLG>
        <TitleSM as={AsSpan} weight="bold">
          /{t('month', 'month')}
        </TitleSM>
      </div>

      <ul className="flex flex-col gap-2">
        <When condition={state.tier.name === 'basic'}>
          <li className="flex items-center gap-2">
            <CircleCheckIcon size={16} color1="black" className="shrink-0 grow-0" />
            <CaptionSM>{t('watchMoviesLimitedAds', 'Watch movies and shows with limited ads')}</CaptionSM>
          </li>
          <li className="flex items-center gap-2">
            <CircleCheckIcon size={16} color1="black" className="shrink-0 grow-0" />
            <CaptionSM>
              <Translate t={t} i18nKey="streamInFullHd">
                Stream in 1080p (Full HD)
              </Translate>
            </CaptionSM>
          </li>
          <li className="flex items-center gap-2">
            <CircleCheckIcon size={16} color1="black" className="shrink-0 grow-0" />
            <CaptionSM>
              <Translate t={t} i18nKey="voteOnShowsV1">
                Vote on concepts and films to decide what we greenlight next
              </Translate>
            </CaptionSM>
          </li>
        </When>
        <When condition={state.tier.name === 'basic-no-ads'}>
          <li className="flex items-center gap-2">
            <CircleCheckIcon size={16} color1="black" className="shrink-0 grow-0" />
            <CaptionSM>{t('watchMoviesWithoutAds', 'Watch movies and shows without ads')}</CaptionSM>
          </li>
          <li className="flex items-center gap-2">
            <CircleCheckIcon size={16} color1="black" className="shrink-0 grow-0" />
            <CaptionSM>
              <Translate t={t} i18nKey="streamInFullHd">
                Stream in 1080p (Full HD)
              </Translate>
            </CaptionSM>
          </li>
          <li className="flex items-center gap-2">
            <CircleCheckIcon size={16} color1="black" className="shrink-0 grow-0" />
            <CaptionSM>
              <Translate t={t} i18nKey="voteOnShowsV1">
                Vote on concepts and films to decide what we greenlight next
              </Translate>
            </CaptionSM>
          </li>
        </When>
      </ul>
      <CaptionSM as={AsDiv} color="info-600" weight="semibold">
        {t('noteMembershipAutoRenewV1', 'Membership will auto-renew unless canceled before end date. Cancel anytime.')}
      </CaptionSM>
    </div>
  )
}
